/* eslint-disable no-restricted-imports */
import "@gx1/gx-ui-common/styles/vars.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { FeatureFlagSessionStorageProvider } from "@gx1/gx-npm-feature-flags";
import App from "./app.component";
import OnboardingComponent from "./sections/onboarding/onboarding.component";
import { HomeAppContextProvider } from "./app.context";
import { GlobalHeaderOffsetProvider } from "@gx1/gx-ui-common";

const Root = () => {
  return (
    <FeatureFlagSessionStorageProvider apiUrl={`${window.gxApiConnection}/api/env`}>
      <HomeAppContextProvider>
        <GlobalHeaderOffsetProvider hasLeftNav={true} hasGlobalHeader={true} hasEvalHeader={false}>
          <BrowserRouter useTransitions={false}>
            <Routes>
              <Route path="/s/home" element={<App />} />
              <Route path="/s/home/onboarding" element={<OnboardingComponent />} />
            </Routes>
          </BrowserRouter>
        </GlobalHeaderOffsetProvider>
      </HomeAppContextProvider>
    </FeatureFlagSessionStorageProvider>
  );
};

export default Root;
